<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="酒店">
        <el-select
          v-model="query.shopId"
          clearable
          filterable
          class="!w-240px"
          placeholder="请选择酒店"
        >
          <el-option v-for="item in hotels" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态"
        ><el-select v-model="query.status" clearable class="!w-150px"
          ><el-option label="待审核" value="PENDING" /><el-option
            label="已通过"
            value="APPROVED" /><el-option label="已驳回" value="REJECTED" /></el-select
      ></el-form-item>
      <el-button type="primary" @click="load">查询</el-button>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-empty v-if="!loading && rows.length === 0" description="暂无资料变更记录" />
    <el-table v-else v-loading="loading" :data="rows">
      <el-table-column prop="shopId" label="酒店 ID" width="100" />
      <el-table-column prop="version" label="版本" width="70" />
      <el-table-column prop="hotelName" label="酒店名称" min-width="150" />
      <el-table-column prop="address" label="地址" min-width="220" />
      <el-table-column prop="settlementSubject" label="结算主体" min-width="150" />
      <el-table-column prop="submitReason" label="变更原因" min-width="180" />
      <el-table-column prop="status" label="状态" width="100" />
      <el-table-column label="操作" width="220"
        ><template #default="{ row }"
          ><el-button link type="primary" @click="viewSensitive(row)">查看敏感资料</el-button
          ><el-button
            v-if="row.status === 'PENDING'"
            link
            type="success"
            @click="auditRow(row, true)"
            >通过</el-button
          ><el-button
            v-if="row.status === 'PENDING'"
            link
            type="danger"
            @click="auditRow(row, false)"
            >驳回</el-button
          ></template
        ></el-table-column
      >
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>
</template>
<script setup lang="ts">
import * as Api from '@/api/hotel/profileChange'
import { getAllHotelShopSimpleList, type HotelPlatformShopOption } from '@/api/hotel/platformShop'
defineOptions({ name: 'HotelPlatformProfileChange' })
const message = useMessage()
const loading = ref(false)
const rows = ref<any[]>([])
const total = ref(0)
const hotels = ref<HotelPlatformShopOption[]>([])
const query = reactive<any>({ pageNo: 1, pageSize: 20, shopId: undefined, status: 'PENDING' })
const load = async () => {
  loading.value = true
  try {
    const data: any = await Api.getPage(query)
    rows.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const auditRow = async (row: any, approved: boolean) => {
  const { value: remark } = await message.prompt(
    approved ? '请输入通过意见' : '请输入驳回原因',
    '资料变更审核'
  )
  await Api.audit({ id: row.id, approved, remark })
  message.success('审核完成')
  await load()
}
const viewSensitive = async (row: any) => {
  const value: any = await Api.getSensitive(row.id)
  await message.alert(
    `结算主体：${value.settlementSubject || '-'}\n资质材料：${value.qualificationJson || '-'}`,
    '敏感资料查看（已记录接口访问）'
  )
}
onMounted(async () => {
  hotels.value = (await getAllHotelShopSimpleList()) || []
  await load()
})
</script>
